var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocument(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.635,
    height: 20.21,
    viewBox: "0 0 17.635 20.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1065 379)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1065 -379)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.076,24.35a.9.9,0,0,0,.9-.9V21.443h2.007a.9.9,0,0,0,.9-.9V8.258c0-.009,0-.017-.005-.026a.414.414,0,0,0-.022-.108.4.4,0,0,0-.014-.04.416.416,0,0,0-.082-.123l-3.7-3.7a.418.418,0,0,0-.124-.083c-.012-.006-.024-.009-.037-.013a.412.412,0,0,0-.112-.022c-.008,0-.016,0-.024,0H10.059a.9.9,0,0,0-.9.9V7.048H7.151a.9.9,0,0,0-.9.9v15.5a.9.9,0,0,0,.9.9Zm.112-18.772,1.13,1.129,1.13,1.129h-2.2a.059.059,0,0,1-.059-.059ZM10,7.469V5.041a.059.059,0,0,1,.059-.059h9.287v2.8a.9.9,0,0,0,.9.9h2.8V20.542a.059.059,0,0,1-.059.059H10.059A.059.059,0,0,1,10,20.542ZM7.092,23.449V7.949a.059.059,0,0,1,.059-.059H9.158V20.542a.9.9,0,0,0,.9.9H20.135v2.007a.059.059,0,0,1-.059.059H7.151A.059.059,0,0,1,7.092,23.449Z",
    transform: "translate(-6.25 -4.14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.89,15.012H24.56a.421.421,0,1,0,0-.842H14.89a.421.421,0,1,0,0,.842Z",
    transform: "translate(-9.454 -8.05)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.89,19.419H24.56a.421.421,0,1,0,0-.842H14.89a.421.421,0,1,0,0,.842Z",
    transform: "translate(-9.454 -9.768)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.89,23.827H24.56a.421.421,0,1,0,0-.842H14.89a.421.421,0,1,0,0,.842Z",
    transform: "translate(-9.454 -11.486)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.89,28.234H24.56a.421.421,0,1,0,0-.842H14.89a.421.421,0,1,0,0,.842Z",
    transform: "translate(-9.454 -13.204)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.6686be5f.svg";
export { ForwardRef as ReactComponent };